import React, { useState } from 'react';
import Icon from '../shared/Icon';
import './Settings.css'; // settings-org-secret, settings-org-eye

/**
 * Masked text input with an eye toggle to reveal/hide the value (PRD-09 SSO fields).
 * Hidden by default; the eye button flips the input between password and text.
 */
function SecretInput({ id, value, onChange, disabled, placeholder }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="settings-org-secret">
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        className="resui-input settings-org-input"
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        autoComplete="off"
        spellCheck={false}
      />
      <button
        type="button"
        className="settings-org-eye"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Hide value' : 'Show value'}
        aria-pressed={visible}
      >
        <Icon name={visible ? 'visibility_off' : 'visibility'} />
      </button>
    </div>
  );
}

export default SecretInput;
